import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isLogged = false;
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() hideSidenav = new EventEmitter<void>();
  @Output() loggedIn = new EventEmitter<void>();
  public customerName = environment.CustomerTitle.toUpperCase();

  constructor(private authSvc: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.authSvc.isLogged$.subscribe((logged) => {
      this.isLogged = logged;

      if (!logged) this.hideSidenav.emit();
      // The shell decides whether to open the menu (it stays closed on tablet).
      if (logged) this.loggedIn.emit();
    });
  }

  onToggleSidenav(): void {
    this.toggleSidenav.emit();
  }

  onLogout() {
    this.authSvc.logout().subscribe();
    this.router.navigate(['login']);
  }
}
